import api from '@/libs/axios'
import { TypeActionAdministratif } from '../models/actionsAdministratif/typeActionAdministratif';
import { PaginatedList } from '../models/common/paginatedList'

const resource = 'TypesActionAdministratif'

export default class TypesActionAdministratifRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, actifOnly?: boolean): Promise<PaginatedList<TypeActionAdministratif>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString());
    if (pagesize) params.append('PageSize', pagesize.toString());
    if (actifOnly) params.append('ActifOnly', actifOnly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
